import React from "react";

interface DicomStudiesIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const strokeProps = {
  strokeWidth: 1.5,
  vectorEffect: "non-scaling-stroke" as const,
};

export const DicomStudiesIcon = ({
  size = 20,
  color = "#7C7F7E",
  className,
}: DicomStudiesIconProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      opacity="0.4"
      d="M20 4.08331C23.1414 4.08331 25.4372 4.08412 27.2236 4.27765C28.996 4.46968 30.1779 4.84417 31.124 5.53156C31.7678 5.99929 32.334 6.56551 32.8018 7.20929C33.4891 8.1554 33.8636 9.3373 34.0557 11.1097C34.2492 12.8961 34.25 15.1919 34.25 18.3333V21.6663C34.25 24.8075 34.2492 27.1036 34.0557 28.89C33.8637 30.6622 33.489 31.8443 32.8018 32.7903C32.3341 33.4341 31.7678 34.0004 31.124 34.4681C30.1779 35.1555 28.996 35.53 27.2236 35.722C25.4372 35.9155 23.1414 35.9163 20 35.9163C16.8586 35.9163 14.5628 35.9155 12.7764 35.722C11.004 35.53 9.82209 35.1555 8.87598 34.4681C8.23226 34.0004 7.66595 33.4341 7.19824 32.7903C6.51095 31.8443 6.13635 30.6622 5.94434 28.89C5.75084 27.1036 5.75 24.8075 5.75 21.6663V18.3333C5.75 15.1919 5.75081 12.8961 5.94434 11.1097C6.13636 9.33731 6.51087 8.1554 7.19824 7.20929C7.66598 6.56551 8.23219 5.9993 8.87598 5.53156C9.82209 4.84418 11.004 4.46967 12.7764 4.27765C14.5628 4.08412 16.8586 4.08331 20 4.08331ZM28.25 25.6751C28.25 23.5701 26.1361 22.2348 24.2822 22.6653C22.9849 22.9669 21.5341 23.137 20 23.137C18.4659 23.137 17.0151 22.9669 15.7178 22.6653C13.8639 22.2348 11.75 23.5701 11.75 25.6751C11.7501 26.7389 12.3371 27.8079 13.416 28.2093C13.9853 28.421 14.5921 28.6053 15.2285 28.7591C16.0183 28.9498 16.6817 29.4572 17.0039 30.1722L17.1807 30.5657C17.6848 31.6838 18.7784 32.4163 20 32.4163C21.2216 32.4163 22.3152 31.6838 22.8193 30.5657L22.9961 30.1722C23.3183 29.4572 23.9817 28.9498 24.7715 28.7591C25.4079 28.6053 26.0147 28.421 26.584 28.2093C27.6628 27.8079 28.2499 26.7389 28.25 25.6751Z"
      fill={color}
      stroke={color}
      {...strokeProps}
    />
    <path
      d="M35 11.6667L35 28.3334C35 32.9357 31.269 36.6667 26.6667 36.6667L13.3333 36.6667C8.73096 36.6667 5 32.9357 5 28.3334L5 11.6667C5 7.06431 8.73096 3.33335 13.3333 3.33335L26.6667 3.33335C31.269 3.33335 35 7.06431 35 11.6667Z"
      stroke={color}
      {...strokeProps}
    />
    <path
      d="M20 8.33331V23.3333"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...strokeProps}
    />
    <path
      d="M20 23.8869C18.4117 23.8869 16.9042 23.7114 15.5483 23.3962C14.0908 23.0575 12.5 24.1255 12.5 25.6749C12.5 26.484 12.9436 27.2335 13.6779 27.5065C14.2174 27.7072 14.7953 27.8829 15.4048 28.0302C16.3911 28.2684 17.2585 28.912 17.6873 29.8637L17.8647 30.2572C18.2523 31.1172 19.0848 31.6667 20 31.6667C20.9152 31.6667 21.7477 31.1172 22.1353 30.2572L22.3127 29.8637C22.7415 28.912 23.6088 28.2684 24.5952 28.0302C25.2047 27.8829 25.7825 27.7072 26.3222 27.5065C27.0563 27.2335 27.5 26.484 27.5 25.6749C27.5 24.1255 25.9092 23.0575 24.4517 23.3962C23.0958 23.7114 21.5883 23.8869 20 23.8869Z"
      stroke={color}
      strokeLinecap="round"
      {...strokeProps}
    />
    <path
      d="M25 11.6667C24.3557 12.6977 23.4733 13.3334 22.5 13.3334C21.5267 13.3334 20.6443 12.6977 20 11.6667C19.3557 12.6977 18.4733 13.3334 17.5 13.3334C16.5267 13.3334 15.6443 12.6977 15 11.6667"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...strokeProps}
    />
    <path
      d="M11.6667 16.6667C12.7406 17.6977 14.2112 18.3334 15.8334 18.3334C17.4556 18.3334 18.9262 17.6977 20.0001 16.6667C21.0739 17.6977 22.5446 18.3334 24.1667 18.3334C25.7889 18.3334 27.2596 17.6977 28.3334 16.6667"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...strokeProps}
    />
  </svg>
);
